import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Vite replaces __BUILD_ID__ at build time; tests and other runtimes fall back to "dev".
const buildId = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'uk', 'es', 'fr', 'pl', 'it', 'pt'],
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${buildId}`,
    },

    detection: {
      order: ['path', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupFromPathIndex: 0,
      lookupLocalStorage: 'i18nextLng',
    },
  });

// Обработчик изменения языка
i18n.on('languageChanged', (lng) => {
  // Обновляем язык в HTML
  document.documentElement.lang = lng;
  // Сохраняем язык в localStorage
  localStorage.setItem('i18nextLng', lng);
});

// Устанавливаем начальный язык
const initialLanguage = localStorage.getItem('i18nextLng') || i18n.language;
document.documentElement.lang = initialLanguage;

export default i18n;
